<form class="w-full flex items-center justify-start">
	<img alt="Busca" src="./assets/icons/search-outline.svg" class="h-4 w-4 mr-4" />
	<input class="focus:outline-none px-2.5 py-1 border w-3/5 md:w-1/3 border-edu-dark-grey text-base font-dinosaur mr-5" placeholder="Pesquisar..." aria-label="Pesquisar" [(ngModel)]="searchString" name="search" />
	<edu-button class="w-2/5" (click)="handleSearchSubmit($event)" variant="secondary">Buscar</edu-button>
</form>
